export default {
  meta: {
    title: '开店区域',
    url: '/sitemap', // 埋点字段，上报归属的模块
    urlName: '开店区域' // 埋点字段，上报归属的模块
  }
};
